import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService, HttpMethod } from '../common/api.service';
import { Theme } from './theme.model';
import { map } from 'rxjs/operators';
import { ThemeEditModel } from './theme-edit.model';

@Injectable({
	providedIn: 'root'
})
export class ThemeApiService extends ApiService
{
	constructor(http: HttpClient)
	{
		super(http)
	}

	getThemes(): Observable<Theme[]>
	{
		return this.apiRequest<any>(this.getThemesUrl(), HttpMethod.Get).pipe(map((json: any) => json.map((item: any) => new Theme(item))));
	}

	getTheme(id: number)
	{
		return this.apiRequest(this.getThemeUrl(id), HttpMethod.Get).pipe(map(json => new Theme(json)));
	}

	createTheme(model: ThemeEditModel)
	{
		return this.apiRequest<any>(this.createThemeUrl(), HttpMethod.Post, JSON.stringify(model)).pipe(map(json => new Theme(json)));
	}

	updateTheme(model: ThemeEditModel)
	{
		return this.apiRequest<any>(this.updateOrDeleteThemeUrl(model.Id), HttpMethod.Put, JSON.stringify(model));
	}

	deleteTheme(theme: Theme)
	{
		return this.apiRequest<any>(this.updateOrDeleteThemeUrl(theme.Id), HttpMethod.Delete, undefined);
	}

	// =========================================================================================================================================================
	// URLs
	// =========================================================================================================================================================
	/* tslint:disable:member-ordering */
	private get baseThemesApiUrl(): string { return `${this.baseApiUrl}themes`; }
	getThemesUrl() { return this.baseThemesApiUrl; }
	getThemeUrl(id: number) { return `${this.baseThemesApiUrl}/${id}`; }
	createThemeUrl() { return this.baseThemesApiUrl; }
	updateOrDeleteThemeUrl(id: number) { return `${this.baseThemesApiUrl}/${id}`; }
}
